import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { resolvedVirusKbDescription } from '@/utils/virus-kb-description'
import RankingChart, { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import PatchInfoPanel from '@/views/dashboard/safe-status/vulnerability-fix/_components/patch-popover/patch-info-panel.vue'
import { VulnerabilityFixService, LeakList, PatchInfo } from '../../vulnerability-fix.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'risk-leak-chart',
  emits: ["itemClick"],
  setup(__props, { emit: __emit }) {

const { t, te, locale } = useI18n()
const injector = useReflectiveInjector([VulnerabilityFixService])
const service = injector.get(VulnerabilityFixService)

const emit = __emit

const isLoading = ref(false)
const rawData = ref<LeakList[]>([])

function formatKbLabel (kb: string) {
  if (!kb) return '--'
  return kb.includes('CVE-') ? kb : `KB${kb}`
}

const rankingData = computed<RankingItem[]>(() =>
  (rawData.value || []).map((row) => ({
    ...row,
    displayName: formatKbLabel(row.kb_number),
    count: row.terminal_count,
  })),
)

function leakRow (item: RankingItem): LeakList {
  return item as unknown as LeakList
}

function leakKbDescForRankingItem (item: RankingItem) {
  void locale.value
  const row = leakRow(item)
  return resolvedVirusKbDescription(row.kb_number, te, t) ?? row.kb_desc ?? ''
}

function patchInfoForRankingItem (item: RankingItem): PatchInfo {
  const row = leakRow(item)
  if (row.patch_info?.kb_number) {
    return row.patch_info
  }
  return { kb_number: row.kb_number || '' } as PatchInfo
}

async function enrichRankingPatchInfo (rows: LeakList[]) {
  await Promise.all(
    rows.map((row) => {
      if (row.patch_info) return Promise.resolve()
      return service
        .getPatchInfo({ kb_number: row.kb_number })
        .then((res) => {
          row.patch_info = res.patch_info
        })
        .catch(() => {})
    }),
  )
}

function loadData () {
  isLoading.value = true
  service
    .getLeakList({
      page: 1,
      limit: 5,
      warn_level: 0,
      kb_number: '',
      sort: 'terminal_count',
      asc: false,
    })
    .then(async (res) => {
      rawData.value = res.list || []
      await enrichRankingPatchInfo(rawData.value)
    })
    .catch(() => {
      rawData.value = []
    })
    .finally(() => {
      isLoading.value = false
    })
}

function onItemClick (item: RankingItem) {
  const kb = item.kb_number as string | undefined
  if (!kb) return
  const row = rawData.value.find((r) => r.kb_number === kb)
  if (row) emit('itemClick', row)
}

loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    class: "chart-card",
    title: _ctx.$t('safeProtectionModule.riskLeakChart'),
    data: rankingData.value,
    "show-time-range": false,
    unit: _ctx.$t('portManage.unitTerminal'),
    "max-items": 5,
    "name-key": "displayName",
    "item-key-field": "kb_number",
    loading: isLoading.value,
    "row-popover": true,
    "popover-width": 380,
    "row-clickable": true,
    onItemClick: onItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    "item-popover": _withCtx(({ item }) => [
      _createVNode(PatchInfoPanel, {
        "patch-info": patchInfoForRankingItem(item),
        "warn-level": leakRow(item).warn_level,
        "description-fallback": leakKbDescForRankingItem(item),
        "pub-date-fallback": leakRow(item).kb_pub_date
      }, null, 8, ["patch-info", "warn-level", "description-fallback", "pub-date-fallback"])
    ]),
    _: 1
  }, 8, ["title", "data", "unit", "loading"]))
}
}

})